import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NavigationModule } from './navigation/navigation.module';
import { FooterComponent } from './footer/footer.component';
import { LanguageSelectorModule } from './language-selector/language-selector.module';

const COMPONENTS = [];

const MODULES = [
    CommonModule,
    LanguageSelectorModule,
    NavigationModule,
    RouterModule,
    FooterComponent,
];

const SERVICES = [];

@NgModule({
    declarations: [COMPONENTS],
    imports: [MODULES],
    exports: [MODULES],
    providers: [SERVICES],
})
export class CoreComponentsModule {}
